export default "__VITE_ASSET__53LjTmW0__"